import React from 'react';
import styles from './Header.module.css';
import Toolbar from '../Toolbar/Toolbar';

const Header = ({
    logo,
    title,
    subtitle,
    navItems = [],
    actions = [],
    toolbarTools = [],
    activeTool,
    onToolChange,
    user,
    onLogoClick,
    onNavClick,
    onUserClick,
    sticky = false,
    className = ''
}) => {
    return (
        <header
            className={`${styles.header} ${sticky ? styles.sticky : ''} ${className}`}
            role="banner"
        >
            <div className={styles.container}>
                {/* 1. Левая часть: Логотип и заголовок */}
                <div 
                    className={styles.brand} 
                    onClick={onLogoClick} 
                    style={{ cursor: onLogoClick ? 'pointer' : 'default' }}
                >
                    <div className={styles.logoWrapper}>
                        {React.isValidElement(logo) ? (
                            logo
                        ) : (
                            <>
                                <img src="/images/logo.png" alt="IChis SPD" className={styles.logoLight} />
                                <img src="/images/logowhite.png" alt="IChis SPD" className={styles.logoDark} />
                            </>
                        )}
                    </div>
                    <div className={styles.titleGroup}>
                        {title && <span className={styles.title}>{title}</span>}
                        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
                    </div>
                </div>

                {/* 2. Центральная часть: Режим и панель инструментов */}
                <div className={styles.centerSection}>
                    {navItems.length > 0 && (
                        <div className={styles.modePillGroup}>
                            {navItems.map((item) => (
                                <button
                                    key={item.id}
                                    type="button"
                                    className={`${styles.modeButton} ${item.active ? styles.modeActive : ''}`}
                                    onClick={(e) => {
                                        if (item.onClick) {
                                            e.preventDefault();
                                            item.onClick();
                                        } else if (onNavClick) {
                                            onNavClick(item);
                                        }
                                    }}
                                    title={item.sublabel ? `${item.sublabel}: ${item.label} (нажмите для переключения)` : item.label}
                                >
                                    {item.icon && <span className={styles.modeIcon}>{item.icon}</span>}
                                    <span className={styles.modeLabel}>{item.label}</span>
                                    <span className={styles.modeSwitchIcon}>⇄</span>
                                </button>
                            ))}
                        </div>
                    )}

                    {/* Встроенный тулбар по центру с плавной анимацией смены инструментов */}
                    {toolbarTools && toolbarTools.length > 0 && (
                        <div key={navItems[0]?.label || 'tools'} className={styles.embeddedToolbarWrapper}>
                            <Toolbar
                                tools={toolbarTools}
                                activeTool={activeTool}
                                onToolChange={onToolChange}
                                className={styles.embeddedToolbar}
                            />
                        </div>
                    )}
                </div>

                {/* 3. Правая часть: Действия, тема и пользователь */}
                <div className={styles.actions}>
                    {user && (
                        <div
                            className={styles.user}
                            onClick={onUserClick}
                            style={{ cursor: onUserClick ? 'pointer' : 'default' }}
                            title={user.name}
                        >
                            {user.avatar ? (
                                <img src={user.avatar} alt={user.name} className={styles.avatar} />
                            ) : (
                                <div className={styles.avatarPlaceholder}>
                                    {user.name?.charAt(0).toUpperCase()}
                                </div>
                            )}
                            <span className={styles.userName}>{user.name}</span>
                        </div>
                    )}

                    {actions.map((action, index) => (
                        action.component ? (
                            <div key={action.id || index} className={styles.actionItem}>
                                {action.component}
                            </div>
                        ) : (
                            <button
                                key={action.id || index}
                                className={styles.actionButton}
                                onClick={action.onClick}
                                disabled={action.disabled}
                                title={action.title}
                                aria-label={action.label || action.title}
                            >
                                {action.icon}
                            </button>
                        )
                    ))}
                </div>
            </div>

            {/* Мобильный тулбар (под шапкой) */}
            <div className={styles.mobileToolbarContainer}>
                <Toolbar
                    tools={toolbarTools}
                    activeTool={activeTool}
                    onToolChange={onToolChange}
                    showLabels={true}
                />
            </div>
        </header>
    );
};

export default Header;
